import { useTranslate } from "@refinedev/core";
import { SettingsTileCard } from "@fawkes/ui";

import type { TileComponentProps } from "./types";

// Gewichtsbandbreedtes — per-breed weight ranges (Epic 15, stories 15-2/15-3). Available in both the
// Organisatie context (platform rules) and a branch context (organisation-specific rules); the detail
// screen scopes new rules to the active context. Opens the in-SPA beheerscherm (BreedWeightRanges).
export const BREED_WEIGHT_TILE_KEY = "breed-weights";

const ITEM_KEYS = [
  "instellingen.item.breedWeights.bands",
  "instellingen.item.breedWeights.ai",
  "instellingen.item.breedWeights.review",
];

export function BreedWeightTile({ onOpenDetail }: TileComponentProps) {
  const t = useTranslate();
  return (
    <SettingsTileCard
      tileKey={BREED_WEIGHT_TILE_KEY}
      icon={<img className="settings-tile-icon-image" src="/nav/nav-dog.svg" alt="" aria-hidden="true" />}
      title={t("instellingen.tile.breedWeights.title")}
      description={t("instellingen.tile.breedWeights.desc")}
      items={ITEM_KEYS.map((k) => t(k))}
      openLabel={t("instellingen.cta.open")}
      onOpen={() => onOpenDetail("breed-weights")}
    />
  );
}
